<template>
  <div class="inputContainer">
    <span :class="{
      'errorMessage' :error,
      'showDollar': (!question.placeholder && !question.prompt) || isCurrentlyFocused || value
    }" class="user-select-none dollar-placeholder">$</span>
    <input
        v-bind="$attrs"
        v-model.lazy="value"
        v-money3="config"
        :disabled="question.status === 'DISABLED'"
        :aria-disabled="question.status === 'DISABLED'"
        ref="currencyInput"
        @input="restrictChar"
        @blur="emitChange"
        @focusin="isCurrentlyFocused = true; $event.target.setSelectionRange(value.length, value.length);"
        @focusout="isCurrentlyFocused = false"
        class='quill-question-input'
        placeholder=""
        :class="{
            invalid: error
          }"
        type='tel'
    />
    <span class="quill-question-placeholder" :class="{'input-filled':value}">{{
        forcePromptPlaceholder ? question.prompt : (question.placeholder || question.prompt)
      }}</span>

  </div>
  <div class="flex-column">
    <div class="subtext errorMessage d-block pt-2" v-html="error"></div>
    <div class="align-text-end" v-if="!disableConfirm && question.value && !error" role="button" @click.stop="$emit('confirm')">Confirm</div>
  </div>


</template>
<script>
/* eslint-disable */

export default {
  name: 'CurrencyInput',
  emits: ['update:modelValue', 'field-error','confirm'],
  props: [
    'question',
    'modelValue',
    'hideSubText',
    'forcePromptPlaceholder',
    'skipEagerValidation',
    'disableConfirm'
  ],
  mounted() {
    if (this.question.value) {
      this.value = this.question.value
    }
    if (!this.skipEagerValidation || this.value) {
      this.validateInput({target: {value: this.value}})
    }
  },
  data() {
    return {
      value: '',
      isCurrentlyFocused: false,
      error: '',
      amount: '',
      config: {
        prefix: '',
        decimal: '.',
        thousands: ',',
        precision: 0,
        masked: true,
        allowBlank: true,
        'disable-negative': true,
      },
    }

  },
  computed: {
    usd() {
      return new Intl.NumberFormat("en-US", {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
  },
  watch: {
    error(newError) {
      if (newError) {
        this.$emit('field-error', true)
      } else {
        this.$emit('field-error', false)
      }
    },
    question: {
      handler: function (newQuestion) {
        if (newQuestion.error) {
          this.error = newQuestion.error
          this.$emit('field-error', true)
        }
        if (newQuestion.value) {
          this.$refs.currencyInput.value = newQuestion.value
          this.$emit('field-error', false)
          this.emitChange({target: {value: newQuestion.value}})
        }
      },
      deep:true
    }
  },
  methods: {
    restrictChar(e) {
      const frontendCriteria = this.question.criteria.find(el => typeof el === 'object')
      e.target.value = e.target.value.replace(/[^0-9]/g, '')
      if (e.target.value.length > String(frontendCriteria?.max_value).length) {
        e.target.value = e.target.value.substring(0, String(frontendCriteria?.max_value).length)
      }
      this.validateInput(e)
    },
    emitChange(e) {
      if (this.validateInput(e)) {
        // Remove commas from the value
        const sanitizedValue = this.value.substring(0).replace(/,/g, '');
        this.$emit('update:modelValue', sanitizedValue);
      }
    },
    validateInput(e) {
      //TODO: AFTER NODE UPDATE TO 14+ CHANGE IF CONDITIONS TO USE OPTIONAL CHAINING AND NULLISH CONVERSION
      const val = e.target.value
      const frontendCriteria = this.question.criteria.find(el => typeof el === 'object')
      const min = frontendCriteria?.min_value || 0;

      const max = frontendCriteria?.max_value || Number.MAX_SAFE_INTEGER;
      this.value = val;

      if (this.question.required && !val ) {
        this.error = `Required`;
        return false
      }

      if (Number(this.value < min)) {
        this.error = `Value must be above ${'$' + this.usd.format(min.toFixed(2))}`
        return false
      }

      if (Number(this.value > max)) {
        this.error = `Value must be below ${'$' + this.usd.format(max.toFixed(2))}`
        return false
      }

      if (this.error) {
        this.error = ''
      }
      return true

    }
  }
}
//TODO:CLEAN UP AND REFINE CSS
</script>
<style scoped lang="scss">

.align-text-end {
  text-align: end;
}

.subtext {
  font-size: .75rem;
  font: normal normal normal 12px/18px Roboto;
  letter-spacing: 0px;
  margin-bottom: 4px;
  color: #757575
}

.errorMessage {
  color: #BB0000
}

.dollar-placeholder {
  position: absolute;
  margin-left: 1rem;
  margin-top: 25.5px;
  font-weight: bold;
  z-index: 9 !important;
  transition: .3s;
  opacity: 0
}

.quill-question {
  > div.inputContainer {
    position: relative;
    min-height: 50px;
    cursor: pointer;

    > .quill-question-input {
      box-sizing: border-box;
      border: 1px solid #ccc;
      border-radius: 3px;
      padding: 16px 5px;
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      background: transparent;
      min-height: 100%;
      @media screen and (max-width: 768px) {
        min-width: auto !important;
        flex: 0 0 45% !important;
      }

      &:has(~.question-type-unknown) {
        border-color: #BB0000;
      }

      &:hover, &:focus {
        border: 2px solid #212121;
        box-shadow: none !important;
        outline: none;
      }

      &:disabled {
        background-color: #EEEEEE;
      }
    }

    .quill-question-placeholder {
      position: absolute;
      padding: 14px 16px;
      line-height: 2em;
      top: 0;
      left: 0;
      color: #757575;
      font-size: 16px;
      pointer-events: none;
      transform: scale(1);
      transition: .26s all ease;
    }

  }


  &.error {
    > b {
      display: block;
    }

    > div {
      border-color: #BB0000;
    }
  }

}

/*TODO convert to scss*/

.quill-question > div.inputContainer > .quill-question-input:focus,
.quill-question > div.inputContainer .quill-question-input:not(.radio,:placeholder-shown) {
  padding: 25px 8px 5px 26px;
}

.input-filled,
.quill-question > div.inputContainer .quill-question-input:focus + .quill-question-placeholder,
.quill-question > div.inputContainer .quill-question-input:not(.radio, :placeholder-shown) + .quill-question-placeholder {
  font-size: 12px;
  padding: 8px 8px 5px 16px;
}

.showDollar {
  opacity: 1 !important;
}

.quill-question > div.inputContainer .quill-question-input:focus ~ ul {
  /*display: block;*/
  visibility: visible;
  transition-delay: 0.1s;
}

.quill-question > div.inputContainer .quill-question-input:focus ~ i {
  transform: rotate(225deg);
}

.form-floating > .form-control:focus ~ label.form-label-text, .form-floating > .form-control:focus ~ label {
  font-size: 12px;
  color: #484848;
  padding-top: 1rem;
}

.form-control-disabled:hover {
  border: none;
}

.form-control-enabled:hover {
  border: 2px solid #212121
}

.invalid {
  border: 1px solid #BB0000 !important;

  &:hover, &:focus, &:focus-within {
    border: 2px solid #BB0000 !important;
  }
}

</style>
